import { Component, OnInit, ViewChild, TemplateRef, EventEmitter, Output } from '@angular/core';
import { UntypedFormBuilder, Validators, UntypedFormGroup } from '@angular/forms';
import { ChatMessage } from './ai-chat-poup-up.model';
import { chatMessagesData } from './data';
import { NgbOffcanvas } from '@ng-bootstrap/ng-bootstrap';

// Date Format
import { DatePipe } from '@angular/common';
import { AIChatService } from '../service/ai-chat.service';
import { ChatBotState } from '../state/chatBot.state';

// Light Box
// import { Lightbox } from 'ngx-lightbox';

@Component({
    selector: 'app-ai-chat-poup-up',
    templateUrl: './ai-chat-poup-up.component.html',
    styleUrls: ['./ai-chat-poup-up.component.scss'],
    standalone: false
})


/**
 * Chat Component
 */
export class AIChatPoupUpComponent implements OnInit {

  @Output() contentChanged = new EventEmitter<void>();

  chatMessages: any;
  isLoading = false;
  isAccordionOpen = false;

  chatMessagesData!: ChatMessage[];
  chatForm!: UntypedFormGroup;
  usermessage!: string;
  isFlag: boolean = false;
  submitted = false;
  isStatus: string = 'online';
  isProfile: string = 'assets/images/favicon2.png';
  username: any = 'AI Deben Assistant';
  @ViewChild('scrollRef') scrollRef: any;
  isreplyMessage = false;
  emoji = '';

  constructor(public _formBuilder: UntypedFormBuilder, private datePipe: DatePipe,
    private _aiChatService: AIChatService) {

  }

  ngOnInit(): void {
    // Validation
    this.chatForm = this._formBuilder.group({
      message: ['', [Validators.required]],
    });
    this.startConversion()
  }

  ngAfterViewInit() {
    this.scrollRef.SimpleBar.getScrollElement().scrollTop = 100;
  }


  /**
   * Returns form
   */
  get form() {
    return this.chatForm.controls;
  }


  /**
   * start the message in chat
   */
  startConversion() {
    this.isLoading = true;
    this._aiChatService.startConversion().subscribe((res: any) => {
      this.chatMessages = res;

      ChatBotState.setChatMessagesState(res);

      this.onListScroll();
      this.isLoading = false;
    }, (err: any) => {
      this.isLoading = false;
    })
  }

  /**
   * scroll the message in chat
   */
  onListScroll() {
    if (this.scrollRef !== undefined) {
      setTimeout(() => {
        const scrollElement = this.scrollRef.SimpleBar.getScrollElement();
        scrollElement.scrollTo({
          top: scrollElement.scrollHeight,
          behavior: 'smooth'
        });
      }, 50);
    }
  }

  /**
   * Save the message in chat
   */
  messageSave() {

    const message = this.chatForm.get('message')!.value;

    if (this.chatForm.valid && message) {
      // this.isLoading = true;
      this.askDebenAssistant()
    }
    this.submitted = true;
  }


  setPredefinedPrompt(prompt: string) {
    this.chatForm.controls['message'].setValue(prompt);
    this.askDebenAssistant()
    this.submitted = true
  }



  /**
   * ask the message in chat
   */

  askDebenAssistant() {
    const content = this.chatForm.get('message')!.value;
    this._aiChatService.askDebenAssistant(this.chatMessages.usersConversationId, { content }).subscribe((res: any) => {
      this.chatMessages = res;
      this.onListScroll();
      // this.isLoading = false;
      this.chatForm = this._formBuilder.group({
        message: null,
      });
      this.contentChanged.emit();
      this.submitted = false;
    }, (err: any) => {
      // this.isLoading = false;
      this.chatForm = this._formBuilder.group({
        message: null,
      });
      this.submitted = false;
    })
  }
}
